module.exports = __webpack_public_path__ + "img/arrow.31b99d6a.svg";